import React from "react";
import styles from "./styles.module.scss";
import IFloatingButtonProps from "../types/floating";
import addSrc from "../../../assets/svgs/add-24px.svg";

export const FloatingActionButton = ({
  disabled,
  onClick,
  className,
  iconSrc,
  ...rest
}: IFloatingButtonProps) => (
  <button
    className={styles.root + (className ? ` ${className}` : "")}
    {...{ disabled, onClick, rest }}
  >
    <img src={Boolean(iconSrc) ? iconSrc : addSrc} />
  </button>
);
